export type ISeries = {
  created: string;
  description: string;
  designer: string;
  frequency: string;
  id: string;
  imageURL: string;
  name: string;
  price: string;
  updated: string;
  is_publisher: boolean;
  webURL: string;
  facebookURL: string;
  twitterURL: string;
  map_count: number;
  map_created: string;
  map_updated: string;
  availability: string;
  avatarURL?: string;
};

export class Series {
  created: string;
  description: string;
  designer: string;
  frequency: string;
  id: string;
  imageURL: string;
  name: string;
  price: string;
  type = 'series';
  updated: string;
  is_publisher: boolean;
  webURL: string;
  facebookURL: string;
  twitterURL: string;
  map_count: number;
  map_created: string;
  map_updated: string;
  availability: string;
  avatarURL?: string;

  constructor({
    created,
    description,
    designer,
    frequency,
    id,
    imageURL,
    name,
    price,
    updated,
    is_publisher,
    webURL,
    facebookURL,
    twitterURL,
    map_count,
    map_created,
    map_updated,
    availability,
    avatarURL,
    ...rest
  }: ISeries) {
    this.created = created;
    this.description = description;
    this.designer = designer;
    this.frequency = frequency;
    this.id = id;
    this.imageURL = imageURL;
    this.name = name;
    this.price = price;
    this.updated = updated;
    this.is_publisher = is_publisher;
    this.webURL = webURL;
    this.facebookURL = facebookURL;
    this.twitterURL = twitterURL;
    this.map_count = map_count;
    this.map_created = map_created;
    this.map_updated = map_updated;
    this.availability = availability;
    this.avatarURL = avatarURL;
    Object.assign(this, rest); // allow old source to edit/persist properties from future versions
  }

  urlId(): string {
    return this.id;
  }
}
